/**
 * Retrieves the app configuration from the global `window.SYDLE` object.
 * @returns The app configuration if available, otherwise `undefined`.
 */
export function getApp() {
    var _a;
    return (_a = window.SYDLE) === null || _a === void 0 ? void 0 : _a.app;
}
